import React from 'react';
import styled from 'styled-components';

import ClickEventLoggerWrapper from '@/components/common/ClickEventLogWrapper';
import InfiniteScroll from '@/components/common/InfiniteScroll';
import LinkTag from '@/components/common/LinkTag';
import ListMagazineLine from '@/components/common/communication/magazine/ListMagazineLine';
import MagazineSkeleton from '@/components/templates/mobile/communication/Magazine/MagazineMobileTemplate/MagazineSkeleton';
import { SearchMagazineViewModel } from '@/hooks/search/magazine/useSearchMagazineViewModel';
import { ROUTES } from '@/types/common';

import EmptySearchResult from '../EmptySearchResult';

interface Props {
  viewModel: SearchMagazineViewModel;
}

const MagazineSearchResult = ({ viewModel }: Props) => {
  if (viewModel.isMagazinesLoading) {
    return <MagazineSkeleton />;
  }

  if (!viewModel.magazinesData?.pages.length) {
    return <EmptySearchResult handleClickRequestButton={viewModel.handleClickRequestButton} />;
  }
  return (
    <Wrapper>
      <InfiniteScroll
        isLoading={viewModel.isMagazinesLoading}
        hasNextPage={viewModel.hasMagazinesNextPage}
        fetchNextPage={viewModel.fetchMagazinesNextPage}
      >
        {viewModel.magazinesData?.pages?.map((magazine) => (
          <LinkTag
            key={`Magazine_${magazine.magazinePid}`}
            onClickNavigateToScreen={() => viewModel.onClickMoveNative(magazine.magazinePid)}
            href={`${ROUTES.MAGAZINE.DETAIL.path}/${magazine.magazinePid}`}
          >
            <ClickEventLoggerWrapper onClickEventLog={() => viewModel.onClickLogMagazine(magazine.magazinePid)}>
              <ListMagazineLine
                titleAsH2={false}
                magazine={{
                  title: magazine.title,
                  mobileTitle: magazine.title,
                  image: magazine.titleImageUrl,
                  date: magazine.createdDate,
                  magazinePid: magazine.magazinePid,
                  description: magazine.description,
                  mobileDescription: magazine.mobileDescription,
                }}
              />
            </ClickEventLoggerWrapper>
          </LinkTag>
        ))}
      </InfiniteScroll>
    </Wrapper>
  );
};

export default MagazineSearchResult;

const Wrapper = styled.ul``;

export const EmptyResultWrapper = styled.div`
  display: inline-grid;
  width: 100%;
  height: ${({ theme }) => `calc(100vh - ${theme.size.appHeader.height})`};
  text-align: center;
  align-items: center;
`;

export const EmptyResultTitle = styled.div`
  ${({ theme }) => theme.typography.UI20SB};
  color: ${({ theme }) => theme.color.gray700};
  margin-top: 20px;
`;

export const EmptyResultOffer = styled.div`
  ${({ theme }) => theme.typography.UI14M};
  color: ${({ theme }) => theme.color.gray400};
  margin: 8px 0 16px;
`;
